var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-cards"},[_c('div',{staticClass:"navigation-cards__container"},[_c('div',{staticClass:"navigation-cards__wrapper[navigation-card]"},_vm._l((_vm.items),function(item,itemIndex){return _c('hot-navigation-card',_vm._b({key:itemIndex},'hot-navigation-card',item,false))}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }